import { createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";
import type * as lazyIndex from "./lazyStatusBarContextMenuIndex";
import type { StatusBarContextMenuProps } from "./components/StatusBarContextMenu";

// StatusBarItems loads with the visible controls; customization loads only on menu invocation.
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "StatusBarContextMenu" */ "./lazyStatusBarContextMenuIndex"), { name: "StatusBarContextMenu" });

export const LazyStatusBarContextMenu: LazyComponent<StatusBarContextMenuProps, unknown, void> = createLazyComponent(lazyModule, m => m.StatusBarContextMenu);
